module.exports = __webpack_public_path__ + "img/GERA_Jobs.jpg";